import ProfileReducer from "./profile";
import AuthReducer from "./auth";
import GeneralReducer from "./general";
import ProjectReducer from "./project";
import AuditionReducer from "./auditions";
import ApplicantsReducer from "./applicants";
import ArtistReducer from "./artist";
import MediaReducer from "./media";
import NotificationReducer from "./notification";
import FolderReducer from "./folder";

/**
 * @author Sarthak Sharma
 * @since 30-01-2024
 * @description to combine recruiter reducers
 */

const recruiterReducer = {
    recruiterAuthReducer: AuthReducer,
    recruiterProjectReducer: ProjectReducer,
    recruiterGeneralReducer: GeneralReducer,
    recruiterProfileReducer: ProfileReducer,
    recruiterAuditionReducer: AuditionReducer,
    recruiterApplicantsReducer: ApplicantsReducer,
    recruiterArtistReducer: ArtistReducer,
    recruiterMediaReducer: MediaReducer,
    recruiterNotificationReducer: NotificationReducer,
    recruiterFolderReducer: FolderReducer,
};

export default recruiterReducer;